/**
 * accountGedeactiveerd.js — een gedeactiveerde docent direct uitloggen (22-10-2026).
 *
 * Deactiveert de schoolbeheerder een docent, dan trekt de database zijn sessies in
 * en weigert elk verzoek met 403 en code ACCOUNT_GEDEACTIVEERD (migratie 104). Het
 * toegangstoken in de browser kan nog tot een uur geldig zijn; zonder deze hulp zag
 * de docent dan alleen lege of kapotte schermen. Nu: bij het eerste geweigerde
 * verzoek lokaal uitloggen en naar /login met een duidelijke melding.
 */

export const CODE_GEDEACTIVEERD = 'ACCOUNT_GEDEACTIVEERD';
export const LOGIN_FOUT_GEDEACTIVEERD = 'account_gedeactiveerd';
export const MELDING_GEDEACTIVEERD = 'Je account is gedeactiveerd door je school. Neem contact op met de schoolbeheerder als je weer toegang nodig hebt.';

/** Fout van de database-API (PostgREST) of de backend voor een gedeactiveerd account? */
export function isAccountGedeactiveerd(fout) {
  if (!fout) return false;
  return fout.code === CODE_GEDEACTIVEERD || fout.code === 'AUTH_ACCOUNT_INACTIVE';
}

/** Docent-rij die niet meer binnen mag (gedeactiveerd of verwijderd). */
export function docentProfielGeblokkeerd(rij) {
  if (!rij) return false;
  return rij.is_actief === false || !!rij.verwijderd_op;
}

/** Naar de inlogpagina met de melding; niet als we daar al staan. */
export function naarLoginGedeactiveerd(locatie = (typeof window !== 'undefined' ? window.location : null)) {
  if (!locatie || (locatie.pathname || '').startsWith('/login')) return false;
  locatie.replace(`/login?error=${LOGIN_FOUT_GEDEACTIVEERD}`);
  return true;
}

/**
 * fetch voor de Supabase-client: geeft elk antwoord ongewijzigd door, maar roept
 * bijGedeactiveerd() aan bij een 403 met code ACCOUNT_GEDEACTIVEERD.
 * @param {Function} basisFetch    de echte fetch
 * @param {Function} bijGedeactiveerd wordt aangeroepen (zonder wachten) bij zo'n 403
 */
export function maakFetchMetToegangscontrole(basisFetch, bijGedeactiveerd) {
  return async (...args) => {
    const antwoord = await basisFetch(...args);
    if (antwoord && antwoord.status === 403 && typeof antwoord.clone === 'function') {
      try {
        const body = await antwoord.clone().json();
        if (body && body.code === CODE_GEDEACTIVEERD) bijGedeactiveerd();
      } catch {
        // geen JSON: niet onze weigering
      }
    }
    return antwoord;
  };
}
